import { z } from 'zod';

/**
 * Single source of truth for the date-range search params shared across routes.
 *
 * The root route validates these globally and `retainSearchParams` keeps them
 * across navigations, so child routes inherit this contract automatically via
 * TanStack Router's parent/child search-schema merge — they must not restate it.
 *
 * Both params are plain optional ISO strings. The only producer
 * (`DateRangeSelector`) sets them to ISO strings or clears them with
 * `undefined`; nothing ever assigns `null`, so the schema does not accept it.
 */
export const dateRangeSearchSchema = z.object({
  startDate: z.string().optional(),
  endDate: z.string().optional(),
});

export type DateRangeSearch = z.infer<typeof dateRangeSearchSchema>;
